/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllComplianceRegistrationLookups = require('../services/GetAllComplianceRegistrationLookups');
var SecIntCompRegEditView = require('../views/SecIntCompRegEditView');
var GetUserComplianceRegistration = require('../services/GetUserComplianceRegistration');

module.exports = function(id) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetAllComplianceRegistrationLookups(), GetUserComplianceRegistration(id))
    .done(function(complianceLookups, userComplianceRegistration) {
      NavUtils.navigate('#sec/compreg/' + id + '/edit');
      Scaffold.content.show(
        new SecIntCompRegEditView({
          model: new Backbone.Model({
            professionalTypes: complianceLookups.professionalTypes,
            userComplianceRegistration: userComplianceRegistration
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
